import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { DecoratedFreightDocument } from '../../../../../core/models/DecoratedFreightDocument';
import { FreightDocument } from '../../../../../core/models/freight-document/FreightDocument';
import { DisplayableColumns } from '../../view-settings/viewSettings';
import { FreightDocumentFlagService } from '../../../../../core/services/freight-document-flag.service';

@Component({
  selector: 'app-document-card',
  styleUrls: ['./document-card.component.scss'],
  templateUrl: './document-card.component.html',
})
export class DocumentCardComponent {
  @Input() freightDocument: DecoratedFreightDocument;
  @Input() columns: DisplayableColumns;
  @Output() openPDFClicked = new EventEmitter<FreightDocument>();
  @Output() acceptDeliveryClicked = new EventEmitter<FreightDocument>();

  protected readonly hasActiveFlags$: Observable<boolean>;

  constructor(private readonly flagService: FreightDocumentFlagService) {
    this.hasActiveFlags$ = this.flagService.hasActiveFlags();
  }
}
